import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {LanguageService} from "../service/language.service";

@Pipe({
  name: 'translateName',
  pure: false
})
@Injectable({ providedIn: 'root' })
export class TranslateNamePipe implements PipeTransform {
  constructor(public languageService: LanguageService) {}

  transform(pavadinimas: any): string {
    return this.languageService.translatePavadinimas(pavadinimas);
  }
}
